module.exports = __webpack_public_path__ + "static/media/coin-large.6e85a648.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/coin-large.png
// module id = 605
// module chunks = 0